export const DATA_KEY = 'dataKey';
export const BACKGROUND_KEY = 'background';
export const EXPAND_RATIO = 0.2; // 拓展比例
